import { render, staticRenderFns } from "./TemplateExport.vue?vue&type=template&id=4dc8a7b6"
import script from "./TemplateExport.vue?vue&type=script&lang=js"
export * from "./TemplateExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports